import { Link, useLocation } from "react-router-dom";

const bottomNavItems = [
  { icon: "ri-home-5-line", activeIcon: "ri-home-5-fill", label: "Home", path: "/" },
  { icon: "ri-store-2-line", activeIcon: "ri-store-2-fill", label: "Market", path: "/marketplace" },
  { icon: "ri-ship-line", activeIcon: "ri-ship-fill", label: "Bulk Order", path: "/buyer-post" },
  { icon: "ri-global-line", activeIcon: "ri-global-fill", label: "Freight", path: "/freight-services" },
  { icon: "ri-user-3-line", activeIcon: "ri-user-3-fill", label: "Account", path: "/vendor-dashboard" },
];

export default function MobileBottomNav() {
  const location = useLocation();

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-stretch h-[62px]">
        {bottomNavItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex-1 flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-colors relative"
            >
              {/* Active top bar */}
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-0.5 bg-amber-400 rounded-full" />
              )}
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl transition-all ${
                isActive ? "bg-amber-400" : ""
              }`}>
                <i className={`${isActive ? item.activeIcon : item.icon} text-xl ${
                  isActive ? "text-white" : "text-gray-400"
                }`}></i>
              </div>
              <span className={`text-[10px] font-semibold leading-none ${
                isActive ? "text-amber-500" : "text-gray-400"
              }`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
